import { GetWithToken, PostWithToken } from "../../../lib/request";

export const getMerchantKey = (storeId) => {
    return async function (dispatch) {
        let url = `/v2/merchant/integration/key`;
        const result = await GetWithToken(url);
        return result;
    }
}

export const regenerateMerchantKey = () => {
    return async function (dispatch) {
        let url = '/v2/merchant/integration/key/generate';
        const result = await PostWithToken(url, {});
        return result;
    }
}
